import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import useApi from "$src/core/hooks/use-api";
import type { HexColorDto, ProfileDto } from "$src/core/models/dto";
import { queryKey as profilesQueryKey } from "$src/core/queries/use-profiles-query";

const MUTATION_KEY = ["profile-update"];

type Variables = {
  id: string;
  name: string;
  tint: HexColorDto;
};

const useUpdateProfileMutation = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();

  const mutationFn = useCallback(
    ({ id, name, tint }: Variables): Promise<ProfileDto> =>
      api.updateProfile(id, { name, tint }),
    [api],
  );

  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: profilesQueryKey() });
    },
  });
};

export default useUpdateProfileMutation;
